import { ErrorZone, guidParamGuard } from 'lemunzo-shared';
import { inviteCodePathParam } from '../constants/route-params';

/**
 * Blocks the client-registration route whose `inviteCode` route parameter is not a well-formed
 * GUID, redirecting back to the registration landing page with a generic error toast.
 */
export const inviteCodeGuard = guidParamGuard(
    inviteCodePathParam,
    '/client-registration',
    ErrorZone.REGISTRATION
);
